"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Functions = require("../core/Functions");

var _Small = _interopRequireDefault(require("../elements/Small"));

var _UIMedia = _interopRequireDefault(require("../layout/UIMedia"));

var _UIMediaBody = _interopRequireDefault(require("../layout/UIMediaBody"));

var _UIMediaLeft = _interopRequireDefault(require("../layout/UIMediaLeft"));

var _UICloseButton = _interopRequireDefault(require("../button/UICloseButton"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _UITruncateString = _interopRequireDefault(require("../text/UITruncateString"));

var customRenderer = _interopRequireWildcard(require("../utils/propTypes/customRenderer"));

var _Styles = require("../utils/Styles");

var _colors = require("HubStyleTokens/colors");

var _misc = require("HubStyleTokens/misc");

var _tshirtSize = require("../utils/propTypes/tshirtSize");

function _templateObject11() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: ", ";\n  padding: ", ";\n  ", ";\n  ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  color: ", ";\n  font-weight: ", ";\n  max-width: 100%;\n  position: relative;\n\n  padding-right: ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      align-self: center;\n      margin-left: auto;\n      margin-right: 0;\n      position: static;\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  flex-shrink: 0;\n  color: ", ";\n  right: 10px;\n  top: 10px;\n  vertical-align: text-top;\n\n  ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  /* bumped so CSS styles from Small doesn't override */\n  && {\n    font-weight: ", ";\n    line-height: inherit;\n    margin-left: ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        min-height: 2rem;\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        align-items: center;\n        flex-direction: row;\n        white-space: nowrap;\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  line-height: 1rem;\n  width: 100%;\n\n  /* extra specificity to override UIMediaBody's styles */\n  && {\n    flex-basis: auto; /* fix IE11 flexbug causing element to have 0 width */\n    margin-left: ", ";\n  }\n\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    ", "\n    max-height: ", ";\n    width: ", ";\n\n    /* flexbug #2 */\n    > * {\n      max-height: ", ";\n      max-width: ", ";\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  align-items: center;\n  display: flex;\n  flex-basis: auto;\n  flex-shrink: 0;\n\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  max-width: 100%;\n  line-height: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin: 0;\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var USE_CLASSES = ['default', 'processing'];
var SIZE_VALUES = {
  fontSize: '12px',
  small: {
    iconFont: '16px',
    previewWidth: '16px'
  },
  large: {
    iconFont: '32px',
    previewWidth: '32px'
  }
};

var StyledAttachment_Children = _styledComponents.default.div.withConfig({
  displayName: "UIFileAttachment__StyledAttachment_Children",
  componentId: "r67tfw-0"
})(_templateObject());

var StyledAttachment_Media = (0, _styledComponents.default)(_UIMedia.default).withConfig({
  displayName: "UIFileAttachment__StyledAttachment_Media",
  componentId: "r67tfw-1"
})(_templateObject2(), function (_ref) {
  var size = _ref.size;
  return size === 'small' && SIZE_VALUES.fontSize;
});
var StyledAttachment_Preview = (0, _styledComponents.default)(_UIMediaLeft.default).withConfig({
  displayName: "UIFileAttachment__StyledAttachment_Preview",
  componentId: "r67tfw-2"
})(_templateObject3(), function (_ref2) {
  var size = _ref2.size;
  return (0, _styledComponents.css)(_templateObject4(), (0, _Styles.setFontSize)(SIZE_VALUES[size].iconFont), SIZE_VALUES[size].previewWidth, SIZE_VALUES[size].previewWidth, SIZE_VALUES[size].previewWidth, SIZE_VALUES[size].previewWidth);
});
StyledAttachment_Preview.displayName = 'StyledAttachment_Preview';
var StyledAttachment_Info = (0, _styledComponents.default)(_UIMediaBody.default).withConfig({
  displayName: "UIFileAttachment__StyledAttachment_Info",
  componentId: "r67tfw-3"
})(_templateObject5(), function (_ref3) {
  var size = _ref3.size;
  return size === 'small' && '8px';
}, function (_ref4) {
  var size = _ref4.size;
  if (size === 'small') return (0, _styledComponents.css)(_templateObject6());else if (size === 'large') return (0, _styledComponents.css)(_templateObject7());
  return null;
});
var FileInfo = (0, _styledComponents.default)(function (_ref5) {
  var className = _ref5.className,
      fileInfo = _ref5.fileInfo,
      size = _ref5.size;
  return fileInfo ? _react.default.createElement(_Small.default, {
    className: className,
    use: "help"
  }, size === 'small' && '(', fileInfo, size === 'small' && ')') : null;
}).withConfig({
  displayName: "UIFileAttachment__FileInfo",
  componentId: "r67tfw-4"
})(_templateObject8(), _misc.WEB_FONT_REGULAR_WEIGHT, function (_ref6) {
  var size = _ref6.size;
  return size === 'small' && '1ch';
});
var StyledAttachment_Close = (0, _styledComponents.default)(function (props) {
  var __attachmentSize = props.attachmentSize,
      rest = (0, _objectWithoutProperties2.default)(props, ["attachmentSize"]);
  return _react.default.createElement(_UICloseButton.default, rest);
}).withConfig({
  displayName: "UIFileAttachment__StyledAttachment_Close",
  componentId: "r67tfw-5"
})(_templateObject9(), _colors.EERIE, function (_ref7) {
  var attachmentSize = _ref7.attachmentSize;
  return attachmentSize === 'small' && (0, _styledComponents.css)(_templateObject10());
});
StyledAttachment_Close.displayName = 'StyledAttachment_Close';

var StyledAttachment = _styledComponents.default.div.withConfig({
  displayName: "UIFileAttachment__StyledAttachment",
  componentId: "r67tfw-6"
})(_templateObject11(), function (_ref8) {
  var size = _ref8.size;
  return size === 'small' ? 'flex' : 'inline-flex';
}, function (_ref9) {
  var size = _ref9.size;
  return size === 'small' ? '8px 12px' : '12px';
}, (0, _Styles.setBorderRadius)(), (0, _Styles.setFontSize)(SIZE_VALUES.fontSize), _colors.GYPSUM, _colors.KOALA, function (_ref10) {
  var use = _ref10.use;
  return use === 'processing' ? _colors.EERIE : _colors.HEFFALUMP;
}, _misc.WEB_FONT_DEMI_BOLD_WEIGHT, function (_ref11) {
  var size = _ref11.size;
  return size === 'large' && '32px';
});

var DefaultFilePreview = function DefaultFilePreview(_ref12) {
  var fileType = _ref12.fileType;
  return _react.default.createElement(_UIIcon.default, {
    className: "align-self-end",
    name: fileType === 'application/pdf' ? 'pdfFile' : 'file'
  });
};

DefaultFilePreview.propTypes = {
  fileType: _react.PropTypes.string
};

var _default = _react.default.createClass({
  displayName: "UIFileAttachment",
  propTypes: {
    children: _react.PropTypes.node,
    closeable: _react.PropTypes.bool.isRequired,
    onCloseClick: _react.PropTypes.func,
    use: _react.PropTypes.oneOf(USE_CLASSES),
    size: _react.PropTypes.oneOfType([(0, _tshirtSize.propTypeForSizes)(['sm', 'lg']), _react.PropTypes.oneOf(['auto'])]).isRequired,
    fileName: _react.PropTypes.node.isRequired,
    fileInfo: _react.PropTypes.node,
    fileType: _react.PropTypes.string,
    renderPreview: customRenderer.propType
  },
  getDefaultProps: function getDefaultProps() {
    return {
      closeable: false,
      use: 'default',
      size: 'large',
      renderPreview: DefaultFilePreview
    };
  },
  handleCloseClick: function handleCloseClick(evt) {
    var onCloseClick = this.props.onCloseClick;
    (0, _Functions.callIfPossible)(onCloseClick, evt);
  },
  render: function render() {
    var _this$props = this.props,
        closeable = _this$props.closeable,
        use = _this$props.use,
        size = _this$props.size,
        children = _this$props.children,
        renderPreview = _this$props.renderPreview,
        fileName = _this$props.fileName,
        fileInfo = _this$props.fileInfo,
        __fileType = _this$props.fileType,
        __onCloseClick = _this$props.onCloseClick,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["closeable", "use", "size", "children", "renderPreview", "fileName", "fileInfo", "fileType", "onCloseClick"]);
    var longhandSize = (0, _tshirtSize.toLonghandSize)(size);
    var renderedPreview = customRenderer.render(renderPreview, this.props, {
      mergeType: 'none'
    });

    var renderedFileInfo = _react.default.createElement(FileInfo, {
      size: size,
      fileInfo: fileInfo
    });

    return _react.default.createElement(StyledAttachment, (0, _extends2.default)({}, rest, {
      size: longhandSize,
      use: use
    }), children && _react.default.createElement(StyledAttachment_Children, {
      size: longhandSize
    }, children), _react.default.createElement(StyledAttachment_Media, {
      size: longhandSize
    }, _react.default.createElement(StyledAttachment_Preview, {
      size: longhandSize
    }, renderedPreview), _react.default.createElement(StyledAttachment_Info, {
      size: longhandSize
    }, longhandSize === 'small' ? _react.default.createElement(_UITruncateString.default, {
      useFlex: true,
      fixedChildren: renderedFileInfo
    }, fileName) : _react.default.createElement(_UITruncateString.default, {
      useFlex: true
    }, fileName), longhandSize !== 'small' && renderedFileInfo)), closeable && _react.default.createElement(StyledAttachment_Close, {
      className: "private-attachment__close",
      onClick: this.handleCloseClick,
      size: "small",
      attachmentSize: longhandSize
    }));
  }
});

exports.default = _default;
module.exports = exports.default;